// extracted by extract-css-chunks-webpack-plugin
module.exports = {"circleIcon":"_36KliG","circleIconResponsive":"_35xV3e","circleIconBig":"_3OyxOM","circleIconSmall":"_1y_x5L"};